module.exports = {"failed":"Login failed","success":"Login successful"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/auth.json
// module id = eOO6
// module chunks = 11